export const Network = {
    MainnetK8s: 'mainnetK8s',
    MainnetLB: 'mainnetLB',
    Mainnet: 'mainnet',
    MainnetSentry: 'mainnetSentry',
    MainnetOld: 'mainnetOld',
    Staging: 'staging',
    Internal: 'internal', // @deprecated
    TestnetK8s: 'testnetK8s',
    TestnetOld: 'testnetOld',
    TestnetSentry: 'testnetSentry',
    Testnet: 'testnet',
    Devnet1: 'devnet1',
    Devnet2: 'devnet2',
    Devnet3: 'devnet3',
    Devnet: 'devnet',
    Local: 'local',
};
